//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RIFLE',

  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/Chart_RIFLE.vue